import { render, staticRenderFns } from "./RicciGagnon.vue?vue&type=template&id=3f5bc20e&"
import script from "./RicciGagnon.vue?vue&type=script&lang=js&"
export * from "./RicciGagnon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports